import { IAppState } from '../../../AppModulesWrapper';

export const selectMultipostingABGroup = (state: IAppState): string | null =>
  state.servicePickerWidget.publishTerms.multipostingABGroup;
